import { sendCPLog } from "../../../Utils/Log/CPlog";
import * as S from "./Benefit.style";
import { RightArrow } from "./RightArrow.svg";

export const BenefitNbc = () => {
  return (
    <S.Container>
      <S.Badge>최대 혜택 과정</S.Badge>
      <S.Gap size={8} />
      <S.SubTitle>커리어 고민 중이신가요?</S.SubTitle>
      <S.Gap size={20} />
      <S.Title>
        <span>IT 취업 코스</span>로<br />
        내일배움카드 최대로 사용하세요!
      </S.Title>
      <S.Gap size={30} />
      <S.BenefitImg src={`/benefit_nbc.png`} />
      <S.Gap size={30} />
      <S.Cta
        onClick={() => {
          sendCPLog("nb_quiz_click_button", {
            "button_text": "더 알아보기"
          })
          window.open("https://nbcamp.spartacodingclub.kr/");
        }}
      >
        더 알아보기 <RightArrow />
      </S.Cta>
      <S.Gap size={30} />
      <S.NoticeContainer>
        내일배움캠프는 코딩교육 1위 스파르타코딩클럽에서 운영하는 KDT(K-Digital
        Training) IT 전문 인력 양성과정입니다.
        <br />
        <br />
        내일배움카드를 활용하여 2,000만원 상당의 IT 취업 코스에 합류할 수
        있으며, IT 전문 교육부터 기간제한 없는 취업 지원을 받을 수 있습니다.
      </S.NoticeContainer>
    </S.Container>
  );
};


